export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY, HH:mm';
export const REG_FLOAT_WITH_ONE_DEC = '(^[0-9]?$)|(^[0-9]+\\.?[0-9]?$)';
export const REG_NUMBER_WITHOUT_DEC = "^[0-9]*$";